import {Controller} from "stimulus";

// Connects to data-controller="other-journals"
export default class extends Controller {

    static targets = ['btnGroup', 'feedback', 'rejectReason']

    connect() {
    }

    handleReject() {
        this.btnGroupTarget.classList.add('is-hidden');
        this.feedbackTarget.classList.remove('is-hidden');
        this.rejectReasonTarget.setAttribute('required', true);
    }

    handleCancel() {
        this.btnGroupTarget.classList.remove('is-hidden');
        this.feedbackTarget.classList.add('is-hidden');
        this.rejectReasonTarget.setAttribute('required', false);
    }

}
